import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * Internal dependencies
 */

import { Block } from './styles/flex-styles';
/**
 * WordPress dependencies
 */

import { forwardRef } from '@wordpress/element';

function FlexBlock(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var classes = classnames('components-flex__block', className);
  return createElement(Block, _extends({}, props, {
    className: classes,
    ref: ref
  }));
}

export default forwardRef(FlexBlock);
//# sourceMappingURL=block.js.map